import React, { Component } from "react";

import styles from "./cmsUser.module.scss";
import { withUsers } from "../../../shared/containers/containerUsers";
import { withOwnershipAreas } from "../../../shared/containers/containerOwnershipAreas";
import { states } from "../../../reducers/queriesStates";
import Scrollbars from "react-custom-scrollbars-2";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Preloader from "../../../shared/items/static/preloader";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";

class CmsUserOwnershipAreas extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      ownershipAreaId: null,
    };
  }

  componentDidMount() {
    const { onGetOwnershipAreas, dataState } = this.props;
    if (dataState === states.NOT_REQUESTED) {
      onGetOwnershipAreas();
    }
  }

  componentDidUpdate(prevProps) {
    const { userOwnershipAreaDataState, errors } = this.props;

    if (userOwnershipAreaDataState === states.FAILURE && prevProps.userOwnershipAreaDataState === states.REQUEST) {
      this.setState({ error: errors });

      setTimeout(() => {
        this.setState({ error: null });
      }, 3000);
    }
  }

  onCreateOwnershipArea() {
    const { onCreateUserOwnershipArea, currentUser, ownershipAreas } = this.props;
    const { ownershipAreaId } = this.state;
    const ownershipArea = ownershipAreas.filter((x) => {
      return x.id === ownershipAreaId;
    })[0];

    onCreateUserOwnershipArea(currentUser.id, ownershipArea);
  }

  onDeleteOwnershipArea(ownershipArea) {
    const { onDeleteUserOwnershipArea, currentUser } = this.props;
    onDeleteUserOwnershipArea(currentUser.id, ownershipArea);
  }

  onSelectOwnershipArea(e) {
    this.setState({ ownershipAreaId: e.target.value });
  }

  render() {
    const { currentUser, ownershipAreas, userOwnershipAreaDataState } = this.props;
    const { error, ownershipAreaId } = this.state;

    return (
      <div>
        <div className={styles.error}>{error}</div>

        <FormControl variant="standard" sx={{ m: 1, minWidth: 250, display: "inline-block" }}>
          <div style={{ display: "flex" }}>
            <Select style={{ minWidth: "700px" }} onChange={this.onSelectOwnershipArea.bind(this)}>
              <MenuItem value={null}>{"- - - "}</MenuItem>
              {ownershipAreas
                .filter((item) => {
                  return !currentUser.ownershipAreas.some((x) => {
                    return x.id === item.id;
                  });
                })
                .map((area) => {
                  return (
                    <MenuItem key={area.id} value={area.id} style={{ display: "block" }}>
                      {area.title}
                    </MenuItem>
                  );
                })}
            </Select>
            <div style={{ paddingLeft: "30px" }}>
              {ownershipAreaId !== null ? (
                <div>
                  {userOwnershipAreaDataState === states.REQUEST ? (
                    <Preloader />
                  ) : (
                    <ButtonPrimary handleClick={this.onCreateOwnershipArea.bind(this)} title="Добавить область владения" />
                  )}
                </div>
              ) : null}
            </div>
          </div>
        </FormControl>

        <Scrollbars ref="scrollbar" style={{ height: "480px" }} autoHide={false}>
          {currentUser.ownershipAreas.map((x) => {
            return (
              <div key={x.id} className={styles.cmsOwnershipItem}>
                <div className={styles.cmOwnershipRemove}>
                  <TooltipWrapper title={`Удалить область`} position="right">
                    <div onClick={this.onDeleteOwnershipArea.bind(this, x)}>
                      <DeleteOutlineIcon fontSize="large" />
                    </div>
                  </TooltipWrapper>
                </div>
                <div>
                  <span>{x.title}</span>
                </div>
              </div>
            );
          })}
        </Scrollbars>
      </div>
    );
  }
}

export default withOwnershipAreas(withUsers(CmsUserOwnershipAreas));
